import { useMemo } from 'react';
import { observer } from 'mobx-react-lite';

import Chip from 'src/components/ui/chip';

import filterStore from 'src/stores/filter-store';

import { IS_MAUSOLEUM_VIEW, LotTypeShown, Rights } from 'src/constants';
import { useLocalization } from 'src/contexts/localization-context';
import { formatPriceRange, getSectionName } from 'src/utils';
import type { FiltersViewProps } from './filters-view.props';

import './filters-view.scss';

const FiltersView = observer(({ bankOptions }: FiltersViewProps) => {
  const { getLocalization } = useLocalization();
  const {
    activeLocation,
    mausoleumsOptions,
    priceRange,
    rights,
    sectionsOptions,
    type,
    handleChangeLocation,
    handleChangePriceRange,
    handleChangeRights,
    handleChangeType,
  } = filterStore;

  const locationName = useMemo(() => {
    if (!activeLocation) {
      return '';
    }

    if (IS_MAUSOLEUM_VIEW) {
      return bankOptions.find(({ id }) => id === activeLocation)?.value ?? activeLocation;
    }

    return (
      mausoleumsOptions.find(({ id }) => activeLocation === id)?.value ||
      getSectionName(
        sectionsOptions.find(({ id }) => activeLocation === id)?.value ?? '',
        getLocalization,
        type
      )
    );
  }, [activeLocation, bankOptions, getLocalization, mausoleumsOptions, sectionsOptions, type]);

  return (
    <div className="filters-view scrollbar scrollbar_horizontal">
      {activeLocation && (
        <Chip isWithClose text={locationName} onClick={() => handleChangeLocation('')} />
      )}
      {priceRange && (
        <Chip
          isWithClose
          text={formatPriceRange(priceRange)}
          onClick={() => handleChangePriceRange(0, 0)}
        />
      )}
      {type && (
        <Chip
          isWithClose
          text={getLocalization(LotTypeShown[type])}
          onClick={() => handleChangeType('')}
        />
      )}
      {rights && (
        <Chip
          isWithClose
          text={getLocalization(Rights[rights])}
          onClick={() => handleChangeRights('')}
        />
      )}
    </div>
  );
});

export default FiltersView;
